import React, { Component } from "react";

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row row-bottom-padded-sm animate-box"
                  data-animate-effect="fadeInLeft"
                >
                  <div className="col-md-12">
                    <div className="about-desc">
                      <span className="heading-meta">About Me</span>
                      <h2 className="colorlib-heading">Who Am I?</h2>
                      <p>
                        Hi there I'm <b>Samarth</b>. <br />I currently work as a Software Engineer at Oracle within the <a href="https://www.oracle.com/cloud/" target="_blank">
                        {" "}
                        Oracle Cloud Infrastructure
                      </a> organization. <br/>Previously I worked as a Software Engineer at a healthcare startup - <a href="https://bola.ai/" target="_blank">
                        {" "}
                        Bola AI
                      </a>{" "} in Boston, MA. <br/>I am really passionate about Full Stack Software Development with a focus in Backend Development.
                        {" "}
                      </p>
                      <p>
                        After graduating with a degree in Information and
                        Communication Technology at{" "}
                        <a href="https://www.daiict.ac.in/" target="_blank">
                          {" "}
                          Dhirubhai Ambani Institute of Information and
                          Communication Technology
                        </a>{" "}
                        in Gandhinagar, India, I decided to explore my interests
                        in Computer Science specifically in Software Development
                        by pursuing a Graduate Computer Science program at the
                        Khoury College of Computer Sciences at{" "}
                        <a
                          href="https://www.khoury.northeastern.edu/"
                          target="_blank"
                        >
                          {" "}
                          Northeastern University
                        </a>{" "}
                        in Boston, USA.
                      </p>
                      <p>
                        During my program at Northeastern, I dove deeper into
                        the field of software development and fell in love with
                        full-stack development. I gained valuable experience by
                        getting an opportunity to work as a Software Engineering
                        Intern at{" "}
                        <a href="https://www.kayak.com/" target="_blank">
                          {" "}
                          KAYAK
                        </a>
                        , which is a travel agency and metasearch engine based
                        in Stamford, USA and at{" "}
                        <a href="https://www.bevi.co/" target="_blank">
                          {" "}
                          Bevi
                        </a>
                        , which is an exciting Boston-based startup. During both
                        these internships, I was heavily involved in projects
                        related to performance and utility and I have been
                        applying that experience in all my current software
                        development endeavors in an attempt to build delightful
                        software for users. <br />I am very passionate about
                        learning new technologies and skills that enhance my
                        career, aid in my overall development and that also help
                        me contribute to the society. I love working in a team,
                        interacting with new people and constantly learning from
                        them.
                      </p>
                      <p>
                        Apart from coding, I am a massive sports enthusiast, and
                        absolutely love Cricket, Tennis, Football and
                        Basketball. I am an ardent Manchester United and Roger
                        Federer fan and am always up for a sports game, debate
                        or discussion. In addition to Sports, I also love traveling, exploring cities and checking out exciting new food places.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-md-3 animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="services color-1">
                      <span className="icon2">
                        <i className="icon-bulb"></i>
                      </span>
                      <h3>Software Development</h3>
                    </div>
                  </div>
                  <div
                    className="col-md-3 animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="services color-2">
                      <span className="icon2">
                        <i className="icon-globe-outline"></i>
                      </span>
                      <h3>Full Stack Development</h3>
                    </div>
                  </div>
                  <div
                    className="col-md-3 animate-box"
                    data-animate-effect="fadeInTop"
                  >
                    <div className="services color-3">
                      <span className="icon2">
                        <i className="icon-data"></i>
                      </span>
                      <h3>Data Structures</h3>
                    </div>
                  </div>
                  <div
                    className="col-md-3 animate-box"
                    data-animate-effect="fadeInBottom"
                  >
                    <div className="services color-4">
                      <span className="icon2">
                        <i className="icon-phone3"></i>
                      </span>
                      <h3>Algorithms</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
